import { handleParams, joinParams } from '../utils'
import qs from 'qs';

/**
 * 报表中心接口 - BI接口
 * add by lty 20190313
 * 
 */
export default {
  /**
   * 报表中心 - 获取房间营收报表总览
   * 文档地址：在阿里云上
   * 
   * @param {+} beginBusinessDay string 经营开始日期（必填）
   * @param {+} endBusinessDay string 经营结束日期（必填）
   * @param {*} chainId number 门店id（必填）
   * 
   * params: handleParams(param)
   */
  getOverview(param) {
    // return this.instance.post('/api/notAuth/guangzhou/finManagementOwnerEchar/countManagementTableInfos', handleParams(param))
    return this.instance.get('/api/notAuth/guangzhou/finManagementOwnerEchar/countChainManageReportForXms', {
      params: param
    })
  },

  /**
   * 报表中心 - 获取房间营收列表接口
   * 文档地址：https://rap2.internal.xbed.com.cn/repository/editor?id=28&itf=4475
   * 
   * @param {+} beginBusinessDay string 经营开始日期（必填）
   * @param {+} endBusinessDay string 经营结束日期（必填）
   * @param {*} chainId number 门店id（必填）
   * @param {*} page number 当前页（必填）
   * @param {*} size number 条数（必填）
   * 
   * params: handleParams(param)
   */
  getRoomReportList(param) {
    return this.instance.post('/api/notAuth/guangzhou/finManagementOwnerEchar/findManagementTableBaseInfo', handleParams(param))
  },

  /**
   * 报表中心 - 获取结算报表明细
   * 文档地址：https://rap2.internal.xbed.com.cn/repository/editor?id=28&itf=4477
   * 
   * @param {+} settlementStartTime string 结算日期起（必填）
   * @param {+} settlementEndTime string 结算日期止（必填）
   * @param {*} chainId number 门店id（必填）
   * @param {*} page number 当前页（必填）
   * @param {*} size number 条数（必填）
   * @param {*} curStartTime string 房费日期起（选填）
   * @param {*} curEndTime string 房费日期止（选填）
   * @param {*} custRoomNo string 房间ID（选填）
   * 
   * params: handleParams(param)
   */
  getSettlementDetail(param) {
    return this.instance.post('/api/notAuth/guangzhou/finApiSettlement/findSettlementDetailsTable', handleParams(param))
  },

  /**
   * 报表中心 - 交易明细 - 支付列表接口
   * 阿里云接口文档地址：https://apigateway.console.aliyun.com/?spm=5176.2020520001.106.d20apigateway.69864bd3kQOu3G#/cn-shenzhen/apis/detail/56ac14f9f0e145b181adfded70bac8fe/f24ddd1abcf3480099f23f644d9b9b2c/definition
   * 
   * @param {*} chain_id number 门店id
   * @param {*} startDate string 开始日期
   * @param {*} endDate string 结束日期
   * @param {*} page number 页数
   * @param {*} size number 每页条数
   * @param {*} source number 订单来源
   * @param {*} orderNo string 订单号
   * @param {*} payWay number 支付方式
   * 
   */
  getPayList(params) {
    return this.instance.get('/api/payList/listByDate', {
      params: params
    })
  },

  /**
   * 报表中心 - 交易明细 - 退款列表接口
   * 阿里云接口文档地址：https://apigateway.console.aliyun.com/?spm=5176.2020520001.106.d20apigateway.69864bd3kQOu3G#/cn-shenzhen/apis/detail/56ac14f9f0e145b181adfded70bac8fe/e8ad123a8cf9482a8e4520ad08c8d54c/definition
   * 
   * @param {*} chain_id number 门店id
   * @param {*} startDate string 开始日期
   * @param {*} endDate string 结束日期
   * @param {*} page number 页数
   * @param {*} size number 每页条数
   * @param {*} source number 订单来源
   * @param {*} orderNo string 订单号
   * @param {*} refundWay number 退款方式
   * @param {*} refundStat number 退款状态（写死2）
   * 
   */
  getRefundList(params) {
    return this.instance.get('/api/refund/listByDate', {
      params: params
    })
  },

  /**
   * 报表中心 - 交易明细 - 导出支付列表接口
   * 阿里云接口文档地址：https://apigateway.console.aliyun.com/?spm=5176.2020520001.106.d20apigateway.69864bd3UdUB81#/cn-shenzhen/apis/detail/3c6c6c263ad545efb17123954221481c/53a3f06f4bc9440c87278e852c602920/definition
   * 
   * @param {*} chain_id number 门店id
   * @param {*} startDate string 开始日期
   * @param {*} endDate string 结束日期
   * @param {*} page number 页数
   * @param {*} size number 每页条数
   * @param {*} source number 订单来源
   * @param {*} orderNo string 订单号
   * @param {*} payWay number 支付方式
   * 
   */
  exportPayList(params) {
    return this.instance.get('/intelligent_reception/api/v1/reports/pays_export', {
      params: params
    })
  },

  /**
   * 报表中心 - 交易明细 - 导出退款列表接口
   * 阿里云接口文档地址：https://apigateway.console.aliyun.com/?spm=5176.2020520001.106.d20apigateway.69864bd3UdUB81#/cn-shenzhen/apis/detail/3c6c6c263ad545efb17123954221481c/e73b8b1635184248b8b2dc35267b110c/definition
   * 
   * @param {*} chain_id number 门店id
   * @param {*} startDate string 开始日期
   * @param {*} endDate string 结束日期
   * @param {*} page number 页数
   * @param {*} size number 每页条数
   * @param {*} source number 订单来源
   * @param {*} orderNo string 订单号
   * @param {*} refundWay number 退款方式
   * 
   */
  exportRefundList(params) {
    return this.instance.get('/intelligent_reception/api/v1/reports/refunds_export', {
      params: params
    })
  },

  /**
   * 退款
   * 阿里云接口文档地址：https://apigateway.console.aliyun.com/?spm=5176.2020520001.106.d20apigateway.69864bd3tz6ELA#/cn-shenzhen/apis/detail/56ac14f9f0e145b181adfded70bac8fe/8187e5f1a5ef4bf9890639b09e9161f7/definition
   * 
   * @param {+}  id 退款单id
   * @param {+}  sourceId
   * @param {+}  refundChannel  2
   * @param {+}  receiveSource 线下
   * @param {+}  bankName 银行名字 -
   * @param {+}  receiveAccount -
   * @param {+}  activeMoney 退款金额 单位：分
   * @param {+}  remark 备注
   * @param {+}  userName 操作人
   */
  confirmRefund(params) {
    return this.instance.post('/api/refund/confirm', joinParams(params))
  },

  /**
   * 房间结算报表 - 详情 - 对应每个月的房间结算明细数据总览接口
   * 阿里云接口文档地址：https://apigateway.console.aliyun.com/?spm=5176.2020520001.106.d20apigateway.69864bd3ww8aRX#/cn-shenzhen/apis/detail/8914062a056e4068be2be00e355137eb/9661ad21d7bd4e75a434d179c4eadf6e/definition
   * 
   * @param {+}  chainId number 门店id（必填）
   * @param {+}  settlementStartTime string 开始日期（必填）
   * @param {+}  settlementEndTime string 结束日期（必填）
   * @param {*}  custRoomNo string 房间ID（选填）
   */
  detailsTotalData(params) {
    return this.instance.get('/api/notAuth/guangzhou/finApiSettlement/countSettlementDetailsTotalData', {
      params: params
    })
  },

  /**
   * 房间结算报表 - 返回半年或者指定月份的数据
   * 阿里云接口文档地址：https://apigateway.console.aliyun.com/?spm=5176.2020520001.106.d20apigateway.69864bd3knbtej#/cn-shenzhen/apis/detail/8914062a056e4068be2be00e355137eb/f490191b847d4074a3158065ee00b0a0/definition
   * 
   * @param {+}  chainId number 门店id（必填）
   * @param {+}  settlementStartTime 开始日期
   * @param {+}  settlementEndTime 结束日期
   */
  roomTotalData(params) {
    return this.instance.get('/api/notAuth/guangzhou/finApiSettlement/countFinSettlementRoomRevenueTotalData', {
      params: params
    })
  },

  /**
   * 报表中心 - 结算账单详情
   * 
   * @param {+} settlementStartTime string 结算日期起（必填）
   * @param {+} settlementEndTime string 结算日期止（必填）
   * @param {*} chainId number 门店id（必填）
   * @param {*} page number 当前页（必填）
   * @param {*} size number 条数（必填）
   * @param {*} curStartTime string 房费日期起（选填）
   * @param {*} curEndTime string 房费日期止（选填）
   * @param {*} custRoomNo string 房间ID（选填）
   * 
   * params: handleParams(param)
   */
  getSettlementDetailTable(param) {
    return this.instance.post('/api/notAuth/guangzhou/finApiSettlement/findSettlementDetailsTableForXms', handleParams(param))
  },

  /**
   * 报表中心 - 新增手工入账
   * 
   * @param {*} chainId number 门店id
   * @param {*} settleDate string 结账月份
   * @param {*} accountDate string 经营日期
   * @param {*} subjectId string 一级科目
   * @param {*} sonSubjectId string 二级科目
   * @param {*} xbedRoomId number Xbed房间ID
   * @param {*} realPrice number 消费金额
   * @param {*} settlementPrice number 结算金额
   * @param {*} remark number 备注
   * @param {*} operatorId number 操作人id
   * @param {*} operatorName number 操作人名字
   * 
   * params: qs.stringify(param)
   */
  addSettlementRecord(param) {
    return this.instance.post('/manualRecord/add', qs.stringify(param))
  },

  /**
   * 报表中心 - 经营利润列表 
   * 
   * @param {*} chainId number 门店id
   * @param {*} month string 月份
   * @param {*} pageNum number 当前页
   * @param {*} pageSize number 条数
   * 
   * params: { ...param }
   */
  getProfitMonthList(param) {
    return this.instance.post('/profitMonth/list', { ...param })
  },

  /**
   * 报表中心 - 经营利润列表 - 经营利润明细
   * 
   * @param {*} id number id 利润明细id
   * 
   * params: url_params: handleParams(param)
   */
  getProfitDetail(param) {
    return this.instance.get('/profitMonth/deatil/:id', {url_params: handleParams(param)})
  },

  /**
   * 报表中心 - 经营利润列表 - 更新经营利润明细项目
   * 
   * @param {*} id number id 利润明细id（必填）
   * @param {*} addItems Array 新增项目数组
   * @param {*} updateItems Array 更新项目数组
   * @param {*} deleteItems Array 删除项目数组
   * 
   * params: { ...param }
   */
  updateProfit(param) {
    return this.instance.post('/profitMonth/deatil/update', { ...param })
  },

  /**
   * 报表中心 - 经营利润列表 - 刷新经营利润明细
   * 
   * @param {*} id number id 利润明细id（必填）
   * 
   * params: url_params: handleParams(param)
   */
  refreshProfit(param) {
    return this.instance.get('/profitMonth/deatil/refresh/:id', { url_params: handleParams(param)})
  },

  /**
   * 报表中心 - 操作记录
   * 
   * @param {*} outId number outId 操作对应的主键id（必填）如：经营利润明细id
   * @param {*} operationType number operationType 操作类型（选填）
                如：1--关账结算 2--手工入账导入 3--手工入账更改 4--手工入账审核 5--经营利润变更
   * 
   * params: params: param
   */
  getTrails(param) {
    return this.instance.get('/operationLog/list', { params: param})
  },

  /**
   * 报表中心 - 每日经营报表
   * 
   * @param {*} chainId number 门店id
   * @param {*} curDate string 经营日期
   * @param {*} pageNum number 当前页
   * @param {*} pageSize number 条数
   * params: params: param
   */
  getDayReports(param) {
    return this.instance.get('/dayProfixReport/list', { params: param})
  },

  /**
   * 获取字典项列表
   * @param {Number} pageNum 
   * @param {Number} pageSize 
   * @param {Number} groupId 
   * @param {String} groupName 
   * @param {String} parentId 
   */
  getDictList(params) {
    return this.instance.post('/api/dictValue/list', joinParams(params))
  },

  /**
   * 账务流水报表
   * @param {String} accountDateStart 经营日期开始时间
   * @param {String} accountDateEnd 经营日期结束时间
   * @param {String} subjectId 一级科目id
   * @param {String} sonSubjectId 二级科目id
   * @param {String} settlementStatus 结算状态(0未结算，1已结算)
   * @param {String} orderSourceId 订单来源id
   * @param {String} payType 交易方式id
   * @param {String} custRoomNo 房间号
   * @param {String} orderNo
   * @param {String} otherNo 渠道单号
   * @param {String} pageNum 页码
   * @param {String} pageSize 页长
   * @param {String} chainId 酒店id
   * @param {String} settleDate 账期月份
   */
  getXMSAccountsReport(params) {
    return this.instance.get('/outConsumptions/xmsAccountsReport', {
      params: handleParams(params)
    })
  },

  /**
   * 获取结算账单月度结算汇总列表
   * @param {String} settleDate 结算月份
   * @param {String} accountStatus 入账状态 0--未入账（默认）,1--已入账
   * @param {String} settlementStatus 结算状态 0未结算，1已结算
   * @param {String} chainId 酒店id
   * @param {Number} pageNum 页码
   * @param {Number} pageSize 每页数
   * @param {Number} settleDate 结算月份
   */
  getSettlementMonthReport(params) {
    return this.instance.get('/outConsumptions/xmsChainMonthReport', {
      params: params
    })
  },

  /**
   * 获取结账月份列表
   * @param {Int} state 0正常 1已关账
   */
  getSettleAccountDateList(params) {
    return this.instance.get('/settle/settleAccountDateList', {
      params: params
    })
  },

  /**
   * 每日经营报表列表数据
   * 
   * @param {String} beginBusinessDay
   * @param {String} endBusinessDay
   * @param {String} chainId
   * @param {String} page
   * @param {String} size
   */
  getDayReportList(params) {
    return this.instance.get('/api/notAuth/guangzhou/finManagementOwnerEchar/countChainManageReportListForXms', {
      params: params
    })
  },

  /**
   * 获取发票统计列表
   * @param {*} page 
   * @param {*} size 
   * @param {*} startDate 
   * @param {*} endDate 
   * @param {*} source 订单来源
   * @param {*} invoiceType 发票类型
   * @param {*} chainId 门店id
   */
  getIncludeEleclInvoice(params) {
    return this.instance.get('/api/invoice/includeElecInvoiceForXms', {
      params: params
    })
  },

  /**
   * 渠道统计表
   * @param {*} beginBusinessDay 开始时间
   * @param {*} endBusinessDay 结束时间
   * @param {*} chainId 
   */
  getCountChannelStatisticsForXms(params) {
    return this.instance.get('/api/notAuth/guangzhou/finManagementOwnerEchar/countChannelStatisticsForXms', {
      params: params
    })
  },

  /**
   * 入住类型统计列表
   * @param {*} beginBusinessDay 开始时间
   * @param {*} endBusinessDay 结束时间
   * @param {*} chainId 
   */
  getSelectRoomRentTypeList(params) {
    return this.instance.get('/api/notAuth/guangzhou/finManagementOwnerEchar/selectRoomRentTypeList', {
      params: params
    })
  },

  /**
   * 房单明细列表
   * @param {*} page 
   * @param {*} size 
   * @param {*} chainId 门店id
   * @param {*} beginBusinessDay 开始时间
   * @param {*} endBusinessDay 结束时间
   * @param {*} stat 1正常 2换房取消 3取消
   * @param {*} rentType 入住类型:1短租，2长租,3钟点
   * @param {*} sourceId 订单来源id
   * @param {*} orderNo 订单号
   * @param {*} otherNo 渠道单号
   */
  getRoomCheckinList(params) {
    return this.instance.get('/api/checkin/roomCheckinListForXms', {
      params: handleParams(params)
    })
  },

  /**
   * 房晚明细列表
   * @param {*} page 
   * @param {*} size 
   * @param {*} chainId 门店id
   * @param {*} beginBusinessDay 开始时间
   * @param {*} endBusinessDay 结束时间
   * @param {*} sourceId 订单来源id
   * @param {*} orderNo 订单号
   * @param {*} otherNo 渠道单号
   * @param {*} roomNo 房间号
   */
  getRoomNightList(params) {
    return this.instance.get('/api/checkin/roomNgintListForXms', {
      params: handleParams(params)
    })
  }

}


// WEBPACK FOOTER //
// ./src/api/report.js